export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17 3a4 4 0 014 4v10a4 4 0 01-4 4H7a4 4 0 01-4-4V7a4 4 0 014-4h10zM8.797 7.226c-2.078 0-3.28 1.777-3.28 4.864 0 2.979 1.166 4.684 3.208 4.684.66 0 1.201-.263 1.622-.744l.084.6h1.321c-.024-1.212-.024-3.387.012-5.068H8.568v1.826h1.226c-.084.948-.457 1.597-.997 1.597-.757 0-1.165-1.069-1.165-2.907 0-1.97.42-3.039 1.14-3.039.517 0 .83.66.925 1.813h2.078c-.108-2.27-1.188-3.626-2.978-3.626zm3.867 9.403h2.042V12.94h1.358v3.688h2.053V7.332h-2.053v3.783h-1.358V7.332h-2.042v9.297z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};